import { MaintenanceMode } from "@/components/MaintenanceMode";
import { useAuth } from "@/context/AuthContext"; // Import useAuth
import { Game } from "@/game/components/Game";
import { HomeScreen } from "@/home/HomeScreen";
import { ProfileScreen } from "@/profile/ProfileScreen";
import { StoreScreen } from "@/store/StoreScreen";
import { Navigate, Route, Routes } from "react-router-dom";
import { MatchmakingScreen } from "./pages/MatchmakingScreen";

export function App() {
  const { isLoading, userId, isMaintenanceMode, maintenanceMessage } = useAuth();

  if (isLoading) {
    return <div className="text-xl">Loading... Authenticating...</div>;
  }

  if (isMaintenanceMode) {
    return <MaintenanceMode message={maintenanceMessage} />;
  }

  if (!userId) {
    return <div className="text-xl">Please log in. (Placeholder - actual login flow TBD)</div>;
  }

  // Authenticated User Routes
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/matchmaking" element={<MatchmakingScreen />} />
        <Route path="/game/:gameId" element={<Game />} />
        <Route path="/profile" element={<ProfileScreen />} />
        <Route path="/store" element={<StoreScreen />} />
        {/* Default fallback route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
